import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Redirect, Route, withRouter } from 'react-router-dom'
import AuthLayout from '../layouts/AuthLayout'
import DefaultLayout from '../layouts/DefaultLayout'
import { inject, observer } from 'mobx-react'
import AuthenticationStore from '../stores/AuthenticationStore'
import ClientLayout from '../layouts/ClientLayout'

@inject('authenticationStore')
@withRouter
@observer
class RouteWrapper extends Component {
  static propTypes = {
    authenticationStore: PropTypes.instanceOf(AuthenticationStore),
    component: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.object]).isRequired,
    isPrivate: PropTypes.bool,
    isClient: PropTypes.bool,
    layout: PropTypes.func,
    skipIfLoggedIn: PropTypes.bool,
    location: PropTypes.object
  }

  static defaultProps = {
    isPrivate: false,
    isClient: false,
    skipIfLoggedIn: false

  }

  render () {
    const { component: Component, isPrivate, skipIfLoggedIn, isClient, layout, ...rest } = this.props
    const { isLoggedIn, initializing } = this.props.authenticationStore
    /**
     * Redirect user to SignIn page if he tries to access a private route
     * without authentication.
     */
    if (isPrivate && !isLoggedIn && !initializing) {
      return <Redirect to='/login' push from={this.props.location.pathname} />
    }
    /**
     * Redirect user to Main page if he tries to access a non private route
     * (SignIn or SignUp) after being authenticated.
     */

    if (isClient && !this.props.authenticationStore.loggedUser.isClient) {
      return <Redirect to='/calendars' />
    }

    let Layout = DefaultLayout
    if (isLoggedIn) {
      if (this.props.authenticationStore.loggedUser.isClient) {
        if (skipIfLoggedIn) {
          return <Redirect to='/next-events' />
        }
        Layout = ClientLayout
      } else {
        if (skipIfLoggedIn) {
          return <Redirect to='/calendars' />
        }
        Layout = AuthLayout
      }
    }
    if (layout) {
      Layout = layout
    }

    /**
     * If not included on both previous cases, redirect user to the desired route.
     */
    return (
      <Route {...rest}>
        <Layout>
          <Component {...rest} />
        </Layout>
      </Route>
    )
  }
}

export default RouteWrapper
